<script>
import {
  ArrowUpIcon
} from "vue-feather-icons";
import countTo from 'vue-count-to';
import Navbar from "@/components/navbar";
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import axios from 'axios';
import account from './admin-pages/member-modify';
import basic from './admin-pages/basic-setting';
import board from './admin-pages/board-setting';
import admlist from './admin-pages/admin-list';
import altong from './admin-pages/altong-member';
import give from './admin-pages/give-member';
import converter from './admin-pages/imsi-converter';
import webAnalytics from './admin-pages/web-analytics';
import sendSms from './admin-pages/send-sms';
import sendEmail from './admin-pages/send-email.vue';
import block from './admin-pages/block';
import mail from './admin-pages/mail';

// 초기세팅
function initialState() {
  return {
    token: "",
    login: {
      idx: 0,
      level: 0,
      nick: "",
      isLogin: false,
    },
    selectedMenu: 'give', // 어드민 들어오면 첫메뉴
  };
}

export default {
  components: {
    Layout,
    Navbar,
    ArrowUpIcon,
    countTo,
    account,
    basic,
    board,
    admlist,
    altong,
    give,
    converter,
    webAnalytics,
    sendSms,
    sendEmail,
    block,
    mail
  },
  data() {
    return initialState();
  },
  computed: {
  },
  mounted() {
    this.first();
  },
  created() {
    if (this.$route.params.adminMenu) { this.selectedMenu = this.$route.params.adminMenu }
  },
  metaInfo() {
    return {
      title: '관리자 페이지 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터 관리자 페이지입니다.'
        },
        {
          property: 'og:title',
          content: '관리자 페이지 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터 관리자 페이지입니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '관리자 페이지 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터 관리자 페이지입니다.'
        }
      ]
    }
  },
  methods: {
    // 처음에 실행되는 부분
    first() {
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
        // 레벨 98 이상이 아니거나 로그인 안한상태면 첫화면으로
        if (this.login.level > 97) {
          // 검증 한번 더
          this.r_is_admin();
        } else {
          //this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다. 013' })
          // 첫화면으로 보내주자
          //this.$router.go("/");
        }
      } else {
        //this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다. 022' })
        // 첫화면으로 보내주자
        //this.$router.go("/");
      }
    },
    // 관리페이지에 접속가능한 사람인지 확인
    async r_is_admin() {
      try {
        await axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_is_admin',
          headers: {
            'access-token': this.token
          },
          data: {
            "mb_idx": this.login.idx,
            "token": this.token,
          },
        })
        .then((res) => {
          if (res.data.type=='success') {
            this.login.isLogin = true
          } else {
            this.login.isLogin = false
            this.$notify({ type: 'error', duration: 3000, title: '실패', text: '관리자 로그인 해주세요'})
            localStorage.removeItem('user');
            this.$store.commit("setAuthIdx", "")
            this.$store.commit("setAuthAccessToken", "")
            this.$store.commit("setAuthNick", "")
            this.$store.commit("setAuthLevel", 0)
            this.$store.commit("setAuthIsLogin", false)
            this.$store.commit("setAuthEmail", "")
            this.$router.go("/");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.text })
            this.login.isLogin = false
            localStorage.removeItem('user');
            this.$store.commit("setAuthIdx", "")
            this.$store.commit("setAuthAccessToken", "")
            this.$store.commit("setAuthNick", "")
            this.$store.commit("setAuthLevel", 0)
            this.$store.commit("setAuthIsLogin", false)
            this.$store.commit("setAuthEmail", "")
            this.$router.go("/");
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        this.login.isLogin = false
        localStorage.removeItem('user');
        this.$store.commit("setAuthIdx", "")
        this.$store.commit("setAuthAccessToken", "")
        this.$store.commit("setAuthNick", "")
        this.$store.commit("setAuthLevel", 0)
        this.$store.commit("setAuthIsLogin", false)
        this.$store.commit("setAuthEmail", "")
        this.$router.go("/");
      }
    },
    selectMenu(val) {
      this.$router.push({ path: `/os/${val}` })
    },
  },
}
</script>

<template>
  <Layout>
    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar :nav-light="true" />

    <section class="bg-profile navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-1"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h4 class="title mb-0"><b class="text-yellow">{{ login.nick }}</b>님 안녕하세요.</h4>
                <h4>
                  <small v-if="login.level == 99" class="text-muted font-size-12 mr-2">최고관리자 권한 사용중입니다.</small>
                  <small v-if="login.level == 98" class="text-muted font-size-12 mr-2">일반관리자 권한 사용중입니다.</small>
                  <small v-if="login.level == 0" class="text-muted font-size-12 mr-2">승인 대기중입니다.</small>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 메인영역 -->
    <section class="mt-4">
      <div class="container">
        <div class="row projects-wrapper">
          <div class="col-xl-8 col-md-12 col-sm-12 col-12 mb-2">
            <div class="p-1 rounded border">
              <div class="overflow-hidden">
                <span class="text-center d-block shadow small h6">
                  일반관리 기능
                </span>
              </div>
              <div class="widget ">
                <ul class="list-unstyled mb-0 font-size-12 text-bold text-secondary d-flex flex-wrap justify-content-center" style="overflow-x: auto;">
                  <li @click="selectMenu('give')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'give'}">
                    <div class="p-1">
                      <span><i class="uil uil-brightness mr-1"></i>정,후원 회원</span>
                    </div>
                  </li>
                  <li @click="selectMenu('altong')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'altong'}">
                    <div class="p-1">
                      <span><i class="uil uil-bell mr-1"></i>알통신청자</span>
                    </div>
                  </li>
                  <li @click="selectMenu('sendSms')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'sendSms'}">
                    <div class="p-1">
                      <span><i class="uil uil-comment-alt-dots mr-1"></i>문자전송</span>
                    </div>
                  </li>
                  <li @click="selectMenu('sendEmail')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'sendEmail'}">
                    <div class="p-1">
                      <span><i class="uil uil-envelope-alt mr-1"></i>메일전송</span>
                    </div>
                  </li>
                  <li @click="selectMenu('web-analytics')" class="cursor-pointer p-1 rounded mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'web-analytics'}">
                    <div class="p-1">
                      <span><i class="uil uil-university mr-1"></i>접속자</span>
                    </div>
                  </li>
                  <li @click="selectMenu('block')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'block'}">
                    <div class="p-1">
                      <span><i class="uil uil-ban mr-1"></i>차단관리</span>
                    </div>
                  </li>
                  <li @click="selectMenu('account')" class="cursor-pointer p-1 rounded mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'account'}">
                    <div class="p-1">
                      <span><i class="uil uil-edit mr-1"></i>내 정보</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-xl-4 col-md-12 col-sm-12 col-12 mb-2">
            <div class="p-1 rounded border text-center">
              <div class="overflow-hidden">
                <span class="text-center d-block shadow small h6">
                  최고관리 기능
                </span>
              </div>
              <!-- 우측 정렬 -->
              <div class="widget">
                <ul class="list-unstyled mb-0 font-size-12 text-bold text-secondary d-flex flex-wrap justify-content-center" style="overflow-x: auto;">
                  <li @click="selectMenu('basic')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'basic'}">
                    <div class="p-1">
                      <span><i class="uil uil-cog mr-1"></i>기본설정</span> 
                    </div>
                  </li>
                  <li @click="selectMenu('board')" class="cursor-pointer p-1 rounded border-right mr-1 mb-1 features fea-primary text-center flex-shrink-0" 
                  :class="{'bg-primary text-white':selectedMenu == 'board'}">
                    <div class="p-1">
                      <span><i class="uil uil-meeting-board mr-1"></i>게시판설정</span> 
                    </div>
                  </li>
                  <li @click="selectMenu('admlist')" class="cursor-pointer p-1 rounded mr-1 mb-1 features fea-primary text-center" 
                  :class="{'bg-primary text-white':selectedMenu == 'admlist'}">
                    <div class="p-1">
                      <span><i class="uil uil-wrench mr-1"></i>권한설정</span> 
                    </div>
                  </li>
                  <li @click="selectMenu('email')" class="cursor-pointer p-1 rounded mr-1 mb-1 features fea-primary text-center" 
                  :class="{'bg-primary text-white':selectedMenu == 'email'}">
                    <div class="p-1">
                      <span><i class="uil uil-wrench mr-1"></i>메일함</span> 
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-xl-12 col-md-12 col-sm-12 col-12 mb-2 ">
            <div class="row">
              <!-- 전체 게시글 -->
              <div v-if="selectedMenu=='allwrite'" class="col-lg-12 col-12">
                <allwrite :selectedMenu="selectedMenu"></allwrite>
              </div>
              <!-- 알통 회원 -->
              <div v-if="selectedMenu=='altong'" class="col-lg-12 col-12">
                <altong :selectedMenu="selectedMenu"></altong>
              </div>
              <!-- 후원 회원 -->
              <div v-if="selectedMenu=='give'" class="col-lg-12 col-12">
                <give :selectedMenu="selectedMenu"></give>
              </div>
              <!-- 관리 계정 -->
              <div v-if="selectedMenu=='admlist'" class="col-lg-12 col-12">
                <admlist :selectedMenu="selectedMenu"></admlist>
              </div>

              <!-- 차단관리 -->
              <div v-if="selectedMenu=='block'" class="col-lg-12 col-12">
                <block :selectedMenu="selectedMenu"></block>
              </div>

              <!-- 이메일 -->
              <div v-if="selectedMenu=='email'" class="col-lg-12 col-12">
                <mail :selectedMenu="selectedMenu"></mail>
              </div>

              <!-- 문자전송 -->
              <div v-if="selectedMenu=='sendSms'" class="col-lg-12 col-12">
                <sendSms :selectedMenu="selectedMenu"></sendSms>
              </div>
              <!-- 이멜전송 -->
              <div v-if="selectedMenu=='sendEmail'" class="col-lg-12 col-12">
                <sendEmail :selectedMenu="selectedMenu"></sendEmail>
              </div>

              <!-- 기본 설정 -->
              <div v-if="selectedMenu=='basic'" class="col-lg-12 col-12">
                <basic :selectedMenu="selectedMenu"></basic>
              </div>
              <!-- 게시판 설정 -->
              <div v-if="selectedMenu=='board'" class="col-lg-12 col-12">
                <board :selectedMenu="selectedMenu"></board>
              </div>
              <!-- 로그인정보 수정 -->
              <div v-if="selectedMenu=='account'" class="col-lg-12 col-12">
                <account :selectedMenu="selectedMenu"></account>
              </div>
              <!-- 개발 히스토리 -->
              <div v-if="selectedMenu=='cording'" class="col-lg-12 col-12">
                <cording :selectedMenu="selectedMenu"></cording>
              </div>
              <!-- 구홈피 이전 -->
              <div v-if="selectedMenu=='converter'" class="col-lg-12 col-12">
                <converter :selectedMenu="selectedMenu"></converter>
              </div>
              <!-- 접속자 통계 -->
              <div v-if="selectedMenu=='web-analytics'" class="col-lg-12 col-12">
                <webAnalytics :selectedMenu="selectedMenu"></webAnalytics>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </Layout>
</template>
